export const getHostname: () => string = () => {
  const hostname: string | undefined =
    (typeof window !== 'undefined' || undefined) &&
    window.location &&
    window.location.hostname;

  if (!hostname || hostname.length === 0) {
    throw new Error(
      'Hostname could not be determined for the current document.'
    );
  }

  return hostname;
};

export const getPathname: () => string = () => {
  const pathname: string | undefined =
    (typeof window !== 'undefined' || undefined) &&
    window.location &&
    window.location.pathname;

  if (!pathname) {
    return '/';
  }

  return pathname;
};
